import { createFileRoute } from "@tanstack/react-router";

import { PraxaAutomationCatalog } from "../components/praxa/PraxaAutomationCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/automations/")({
  component: PraxaAutomationsRoute,
});

function PraxaAutomationsRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaAutomationCatalog view="automations" workspaceId={workspaceId} />;
}
